<template>
  <!-- 大转盘抽奖 -->
  <div class="container">
    <div
      class="turnplateLottery"
      :class="{ spining: spining }"
      :style="[rotateStyle, turnplateBgStyle]"
      ref="turnplate"
    >
      <div
        class="awardItem"
        v-for="i in sectorItems"
        :key="i.id"
        :style="i.styleObj"
      >
        <span v-if="isShowAwardTitle" class="awardName">{{ i.name }}</span>
        <div
          class="awardIcon"
          :class="[awardSize, isShowAwardTitle ? 'withTitle' : 'withoutTitle']"
        >
          <Award :awardData="i" />
        </div>
      </div>
    </div>
    <div class="fireBtn" @click="handleFire" :style="fireBtnBgStyle"></div>
  </div>
</template>

<script>
import Award from './LotteryAward';
import { isIOS } from '@/utils';

function calcClip(amount) {
  // 根据奖品数计算裁剪坐标
  switch (true) {
    case amount === 2:
      return '0 50%, 0 0, 100% 0, 100% 50%';
    case amount === 3:
      return `0 ${50 * (1 - Math.tan(Math.PI / 6))}%, 0 0, 100% 0, 100% ${50 *
        (1 - Math.tan(Math.PI / 6))}%, 50% 50%`;
    case amount === 4:
      return `0 0, 100% 0, 50% 50%`;
    case amount > 4:
      return `${50 * (1 - Math.tan(Math.PI / amount))}% 0, ${Math.tan(
        Math.PI / amount
      ) *
        50 +
        50}% 0, 50% 50%`;
  }
}
export default {
  components: {
    Award
  },
  props: {
    lotteryAwards: Array,
    lotterySetting: Object,
    lotteryResult: Array,
    lotteryTicketCount: Number,
    isShowAwardTitle: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    lotteryResult: function(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (newVal.length) {
          this.rollingToTargetId(newVal[0].rewardPoolId);
          this.reportDraw(1);
        } else {
          this.reset();
          this.reportDraw(0);
          this.$emit('lotteryFinish');
        }
      }
      if (oldVal && !newVal) {
        this.reset();
      }
    }
  },
  data() {
    return {
      spining: false,
      rotateStyle: {}
    };
  },
  created() {
    this.lotteryPending = false;
  },
  computed: {
    baseClip() {
      return calcClip(this.lotteryAwards.length);
    },
    sectorItemDeg() {
      return 360 / this.lotteryAwards.length;
    },
    fireBtnBgStyle() {
      return {
        background: `center / contain url("${this.lotterySetting.buttonImage}") no-repeat`
      };
    },
    turnplateBgStyle() {
      return {
        background: `center / contain url("${this.lotterySetting.backgroundImage}") no-repeat`
      };
    },
    awardSize() {
      // 奖品图片大小
      const awardCount = this.lotteryAwards.length;
      switch (true) {
        case awardCount < 6:
          return 'big';
        case awardCount === 6:
          return 'normal';
        case awardCount > 6:
          return 'small';
        default:
          return 'normal';
      }
    },
    /**
     * 使用 clipPath: `polygon()` 实现扇形裁剪
     */
    sectorItems() {
      return this.lotteryAwards.map((award, index) => {
        const rotateOffset = index * this.sectorItemDeg;
        return {
          ...award,
          styleObj: {
            webkitClipPath: `polygon(${this.baseClip})`,
            clipPath: `polygon(${this.baseClip})`,
            transform: `rotate(${rotateOffset}deg)`
          },
          stopRotateDeg: 1080 - rotateOffset
        };
      });
    }
  },
  methods: {
    checkTicket() {
      const hasTicket = this.lotteryTicketCount > 0;
      if (!hasTicket) {
        this.$emit('noTicket');
      }
      return hasTicket;
    },
    /**
     * 点击抽奖
     */
    handleFire() {
      if (this.lotteryPending) {
        this.$hll.toast({ message: '请勿重复点击', timeout: 500 });
        return;
      }
      // 抽奖机会检查
      if (!this.checkTicket()) {
        this.reportDraw(0);
        return;
      }
      this.lotteryPending = true;
      this.$emit('fire');
      // 转盘开启
      this.spining = true;
    },
    /**
     * 点击抽奖后使用 infinite animation 触发无限旋转，获得抽奖结果后
     * 停止无限旋转，然后用 transform: rotate() 旋转至指定角度
     */
    rollingToTargetId(id) {
      const _this = this;
      const target = this.sectorItems.find(i => i.rewardPoolId === id);
      const stopRotateDeg = target.stopRotateDeg;
      if (this.nonsupportUpdateAnimationState()) {
        this.spining = false;
        this.setTransitionToTarget(stopRotateDeg);
      } else {
        this.rotateStyle = {
          animationIterationCount: 0 // 停止旋转的 animation
        };
        this.$refs.turnplate.addEventListener(
          'animationend',
          function handleAnimationEnd() {
            this.spining = false;
            _this.setTransitionToTarget(stopRotateDeg);
            // 有设备不支持once，所以手动移除监听
            _this.$refs.turnplate.removeEventListener(
              'animationend',
              handleAnimationEnd
            );
          },
          {
            once: true
          }
        );
      }
    },
    setTransitionToTarget(stopRotateDeg) {
      const _this = this;
      // 根据奖品所在角度触发rotate
      this.rotateStyle = {
        transition: 'transform 2s ease-out',
        transform: `rotate(${stopRotateDeg}deg)`
      };
      this.spining = false;
      this.$refs.turnplate.addEventListener(
        'transitionend',
        function handleTransitionEnd() {
          setTimeout(() => {
            _this.$emit('lotteryFinish');
          }, 300);
          _this.lotteryPending = false;
          // 有设备不支持once，所以手动移除监听
          _this.$refs.turnplate.removeEventListener(
            'transitionend',
            handleTransitionEnd
          );
        },
        {
          once: true
        }
      );
    },
    reset() {
      this.spining = false;
      this.lotteryPending = false;
      this.rotateStyle = {};
    },
    reportDraw(is_success = 1) {
      this.$emit('reportDraw', {
        is_success
      });
    },
    nonsupportUpdateAnimationState() {
      return isIOS() && !document.getAnimations;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  display: flex;
  justify-content: center;
}
.turnplateLottery {
  position: relative;
  width: 540px;
  height: 540px;
  border-radius: 50%;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-perspective: 1000;
  perspective: 1000;

  &.spining {
    animation: infinite-rotate infinite 0.5s linear;
  }

  .awardItem {
    position: absolute;
    width: 540px;
    height: 540px;
    border-radius: 50%;
    overflow: hidden;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    span.awardName {
      margin-top: 20px;
      margin-bottom: 5px;
      font-size: 24px;
      color: #333;
    }

    .awardIcon {
      &.withTitle {
        margin-top: 0px;
      }

      &.withoutTitle {
        margin-top: 50px;
      }

      &.big {
        flex: 0 0 110px;
        width: 110px;
        height: 110px;
        font-size: 25px;
      }

      &.normal {
        flex: 0 0 100px;
        width: 100px;
        height: 100px;
        font-size: 23px;
      }

      &.small {
        flex: 0 0 90px;
        width: 90px;
        height: 90px;
        font-size: 15px;
      }
    }
  }
}
.fireBtn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: none;
  width: 160px;
  height: 190px;
}
@keyframes infinite-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
